import { useState, useEffect } from 'react';
import { useMobile } from '../../utils/mobileContext';
import './pageMenu.css';

function PageMenu({ items = [], defaultActive, title, active, onActiveChange }) {
    const menuItems = Array.isArray(items) ? items : [];

    const [activeMenu, setActiveMenu] = useState(
        active || defaultActive || (items && items[0] && items[0].key) || null
    );

    const isMobile = useMobile(670);

    useEffect(() => {
        if (active !== undefined) {
            setActiveMenu(active);
        }
    }, [active]);

    useEffect(() => {
        if ((!activeMenu || !menuItems.find(i => i.key === activeMenu)) && menuItems.length) {
            setActiveMenu(menuItems[0].key);
        }
    }, [items]);

    const handleSetActive = (key) => {
        setActiveMenu(key);
        if (onActiveChange) {
            onActiveChange(key);
        }
    };

    const activeItem = menuItems.find(i => i.key === activeMenu) || null;

    const ActiveComponent = activeItem && activeItem.component ? activeItem.component : null;

    return (
        <div className='pageContainer'>
            <h1>{title || 'Seitenname nicht gefunden'}</h1>
            <div className='pageMenuMenu'>
                {isMobile ? (
                    <select
                        value={activeMenu || ''}
                        onChange={e => handleSetActive(e.target.value)}
                        className='pageMenuSelect'
                    >
                        {menuItems.map(item => (
                            <option key={item.key} value={item.key}>{item.label}</option>
                        ))}
                    </select>
                ) : (
                    menuItems.map(item => {
                        const isActive = activeMenu === item.key;
                        const itemClass = isActive ? 'pageMenuActiveItem' : 'pageMenuListItem';

                        return (
                            <p
                                key={item.key}
                                className={itemClass + ' pageMenuItemStyle'}
                                onClick={() => handleSetActive(item.key)}
                            >
                                {item.label}
                            </p>
                        );
                    })
                )}
            </div>
            {/* {ActiveComponent ? <ActiveComponent /> : null} */}
            {ActiveComponent ? ActiveComponent() : null}
        </div>
    );
}

export default PageMenu;